export const DEFAULT_PRODUCT_MEDIA_ORIGIN = 'https://ip-com-app.oss-cn-shenzhen.aliyuncs.com'
export const DEFAULT_STATIC_ASSET_ORIGIN = 'https://ip-com-app.oss-cn-shenzhen.aliyuncs.com'
export const DEFAULT_STATIC_ASSET_PREFIX = '/ip-com/public'
export const DEFAULT_TENDA_PUBLIC_STATIC_ASSET_ORIGIN = 'https://public.tenda.com.cn'
export const DEFAULT_TENDA_PUBLIC_STATIC_ASSET_PREFIX = '/tenda/public'

/**
 * @description 统一解析静态资源 OSS 运行时配置，给构建和运行时都保留稳定兜底。
 * @param {Record<string, any>} [publicConfig={}] - runtimeConfig.public 或等价对象
 * @returns {{ staticAssetOrigin: string, staticAssetPrefix: string }}
 */
export const resolveStaticAssetRuntimeConfig = (publicConfig = {}) => {
  const staticAssetOrigin = (publicConfig.staticAssetOrigin || DEFAULT_STATIC_ASSET_ORIGIN).replace(
    /\/+$/g,
    ''
  )
  const staticAssetPrefix = (publicConfig.staticAssetPrefix || DEFAULT_STATIC_ASSET_PREFIX).replace(
    /\/+$/g,
    ''
  )

  return {
    staticAssetOrigin,
    staticAssetPrefix,
  }
}

/**
 * @description Resolve the dedicated public bucket used by Tenda-owned static assets.
 * @param {Record<string, any>} [publicConfig={}] - runtimeConfig.public or an equivalent object.
 * @returns {{ staticAssetOrigin: string, staticAssetPrefix: string }}
 */
export const resolveTendaPublicStaticAssetRuntimeConfig = (publicConfig = {}) => {
  const staticAssetOrigin = (
    publicConfig.tendaPublicStaticAssetOrigin || DEFAULT_TENDA_PUBLIC_STATIC_ASSET_ORIGIN
  ).replace(/\/+$/g, '')
  const staticAssetPrefix = (
    publicConfig.tendaPublicStaticAssetPrefix || DEFAULT_TENDA_PUBLIC_STATIC_ASSET_PREFIX
  ).replace(/\/+$/g, '')

  return {
    staticAssetOrigin,
    staticAssetPrefix,
  }
}
